import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient, Sound } from '@benzinga/session';
import { IncomingAuthorResult, IncomingCategoryResult, IncomingCategoryUpdateResult } from './ingress';
import { Session } from '@benzinga/session';
import { NewsAlertsEnvironment } from './environment';
import { CategoryId } from '@benzinga/advanced-news-manager';

export class NewsAlertsRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(NewsAlertsEnvironment).url, session, { 'x-device-key': true });
  }

  public getCategoriesAlerts = (): SafePromise<IncomingCategoryResult> => {
    const url = this.URL('api/v2/watchlists/channel');
    return this.get(url, { allowsAnonymousAuth: true });
  };

  public setCategoriesAlerts = (
    categoryId: CategoryId,
    sound?: Sound,
    realtimeEmail?: boolean,
  ): SafePromise<IncomingCategoryUpdateResult> => {
    const url = this.URL(`api/v2/watchlists/channel`);
    return this.patch(url, {
      channel_id: categoryId,
      sound,
      subscription_type: realtimeEmail,
    });
  };

  public createAuthorSubscription = (authorId: number, authorName: string): SafePromise<IncomingAuthorResult> => {
    const url = this.URL(`api/v2/watchlists/alerts/type/author`);
    return this.post(url, { alert_name: authorName, author_id: authorId, send_realtime: true });
  };

  public getAuthorSubscriptions = (): SafePromise<IncomingAuthorResult> => {
    const url = this.URL('api/v2/watchlists/alerts/type/author');
    return this.get(url);
  };

  public removeAuthorSubscription = (alertId: number): SafePromise<any> => {
    const url = this.URL(`api/v2/watchlists/alerts/${alertId}`);
    return this.delete(url);
  };

  public getUnsubscribeAllKey = (): SafePromise<any> => {
    const url = this.URL('api/v2/watchlists/unsubscribe_key');
    return this.get(url);
  };
}
